<div class="infoMessage" [innerHTML]="infoText | hisHtmlUnsafe"></div>
<br />
<div class="layoutBlock">
    <button [disabled]="jobStatus" (click)="onSubmitSearch()">
        <span>{{ 'common.search' | hisUi }}</span>
    </button>
    <button (click)="resetInputs();">
        <span>{{ 'common.reset' | hisUi }}</span>
    </button>
    <div class="columnFullWidth">
        <p-panel header="{{'cs.psv.person.idAssignment.orcid.search.form.header' | hisUi}}">
            <his-plam>
                <input (keyup.enter)="onSubmitSearch()" [formControl]="searchKeyword" required hisDdKey="cs.psv.person.idAssignment.orcid.search.form.label.searchWord" #content class="inputWidth100">
            </his-plam>
            <div *ngIf="jobStatus">
                <p-progressBar [value]="+((jobStatus.numSuccessfulItems + jobStatus.numFailedItems) * 100 / jobStatus.numTotalItems | number: '1.0-0')"></p-progressBar>
            </div>
        </p-panel>
    </div>
    <button [disabled]="jobStatus" (click)="onSubmitSearch()">
        <span>{{ 'common.search' | hisUi }}</span>
    </button>
    <button (click)="resetInputs();">
        <span>{{ 'common.reset' | hisUi }}</span>
    </button>
</div>

